<template>
  <div>
	  <div class="bottom_circle">
		  <div class="enter_title_wrap">
			<div class="enter_inner">
			<div class="inner_left">
				<img src="../../assets/img/tupianright.png" alt="" />
			</div>
			<div class="inner_center">
				<div class="enter_title">解决方案</div>
				<div class="enter_desc"></div>
			</div>
			<div class="inner_right">
				<img src="../../assets/img/tupianleft.png" alt="" />
			</div>
			</div>
		  </div>
	  </div>
	  <div class="advantage_out_wrap">
		  <el-row class="advantage_wrap">
			<el-col
			  class="advantage_item"
			  v-for="(item, index) in advantageList"
			  :key="index"
			  :span="5"
			  :xs="11"
			  :data-aos="item.fade"
			>
			  <div class="item_top">
				<div class="icon"><img :src="item.icon" alt=""></div>
				<div class="tit">{{ item.title }}</div>
			  </div>
			  <ul class="item_desc hidden-xs-only" v-for="(desc, index2) in item.desc" :key="index2">
				<li>{{ desc }}</li>
			  </ul>
			</el-col>
		  </el-row>
	  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      advantageList: [
        {
          icon: require('../../assets/img/programme/industryInsight/icon/41.png'),
          title: '产品成熟已经多项目验证',
          desc: [
            '亿微电子解决方案已在全国多个城市得到应用，覆盖按摩椅等多个高精尖产业',
            '已形成产业地图、产业监测、企业培育、风险监测等多个场景成熟应用',
          ],
		  fade: 'fade-right',
        },
        {
          icon: require('../../assets/img/programme/industryInsight/icon/42.png'),
          title: '弹性架构支撑快速构建应用',
          desc: [
            '通过实际项目提炼产业见解、产业图谱和算法模型形成PaaS层',
            '支撑快速构建扩展多产业链应用场景',
          ],
		  fade: 'fade-right',
        },
        {
          icon: require('../../assets/img/programme/industryInsight/icon/43.png'),
          title: '指标+模型构建产业洞察力',
          desc: [
            '微观形成数字化企业画像',
            '宏观绘制产业链全景谱图，进行指标评价',
            '构建供应链健康度、企业潜力、风险预测、外迁预警等大数据模型',
          ],
		  fade: 'fade-left',
        },
        {
          icon: require('../../assets/img/programme/industryInsight/icon/44.png'),
          title: '建成公域产业数据中心形成丰富的产业链核心场景应用',
          desc: [
            '数据智能支撑产业链图谱绘制和应用场景构建',
            '自主研发超级数据工厂，实现数据采集、加工、融合智能化',
          ],
		  fade: 'fade-left',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.bottom_circle {
  width: 100%;
  text-align: center;
  padding-top: 50px;
  background-image: url(../../assets/img/smalldot.png),url(../../assets/img/smalldot1.png);
  background-position: 0 0,110% 150%;
  background-repeat: no-repeat;
  background-size: 400px;
	.enter_title_wrap {
	  width: 100%;
	  margin-top: 100px;
	  @media screen and (max-width: 768px) {
		margin-top: 30px;
	  }
	  .enter_inner {
		display: flex;
		justify-content: center;
		.inner_left {
		  display: flex;
		  justify-content: flex-end;
		  align-items: center;
		  @media screen and (max-width: 768px) {
			flex: 1;
		  }
		  img {
			width: 30%;
		  }
		}
		.inner_center {
		  width: 400px;
		  display: flex;
		  flex-direction: column;
		  justify-content: center;
		  align-items: center;
		  padding: 0 50px;
		  @media screen and (max-width: 768px) {
			flex: 2.2;
		  }
		  .enter_title {
			font-size: 40px;
			font-weight: bold;
			@media screen and (max-width: 768px) {
			  font-size: 1rem;
			}
		  }
		  .enter_desc {
			font-size: 16px;
			color: #787878;
			margin-top: 10px;
			@media screen and (max-width: 768px) {
			  margin-top: 10px;
			}
		  }
		}
		.inner_right {
		  display: flex;
		  justify-content: flex-start;
		  align-items: center;
		  @media screen and (max-width: 768px) {
			flex: 1;
		  }
		  img {
			width: 30%;
		  }
		}
	  }
	}
  .circle_img {
    width: 100%;
    img {
      width: 70%;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin: 20PX 0;
      }
    }
  }
}
.advantage_out_wrap {
	width: 100%;
	display: flex;
	justify-content: center;
	.advantage_wrap {
	  width: 70%;
	  display: flex;
	  margin-top: 70px;
	  justify-content: space-between;
	  flex-wrap: wrap;
	  @media screen and (max-width: 768px) {
		width: 100%;
		justify-content: center;
	  }
	  .advantage_item:hover {
		transform: scale(1.2); /* 放大比例 */
	  }
	  .advantage_item {
		transition: transform 0.5s ease; /* 过渡效果 */
		height: auto;
		padding: 30px 20px 80px 20px;
		margin-right: 10px;
		background: 
		        linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)), /* 半透明白色层 */
		        url('../../assets/img/jjfa_back.png') 0 0 no-repeat;
		background-size: 100% 100%;
		@media screen and (max-width: 768px) {
		  margin: 0;
		  padding: 0 15px;
		  margin-top: 3px;
		  height: 140px;
		  display: flex;
		  justify-content: center;
		  align-items: center;
		}
		.item_top {
		  display: flex;
		  align-items: center;
		  @media screen and (max-width: 768px) {
			height: 100px;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			text-align: center;
		  }
		  .icon {
			width: 15%;
			margin-right: 10PX;
			display: flex;
			justify-content: center;
			align-items: center;
			img {
			  width: 100%;
			  @media screen and (max-width: 768px) {
				margin-bottom: 10px;
				margin-left: 6px;
			  }
			}
		  }
		  .tit {
			width: 100%;
			color: #1c1c1c;
			font-size: 22px;
			font-weight: bold;
			@media screen and (max-width: 768px) {
			  font-size: 1rem;
			}
		  }
		}
		.item_desc {
		  font-size: 16px;
		  line-height: 20PX;
		  margin: 0;
		  padding: 0;
		  margin-top: 20px;
		  padding-left: 34px;
		  color: #646464;
		  li{
			  &:first-child{
				margin-top: 30px;
			}
		  }
		}
	  }
	}
}
</style>